import React, { Component } from 'react';
import CheckBox from './check';
import InputBox from './input';
import SelectBox from './select';
import TextFieldBox from './textfield';
import DateBox from './date';
import FileBox from './file';

class CommonForm extends Component {
    state = {
        data: {},
      };
      handleChnage = (e) => {
      }
    renderInput(name,label,rules,){
        const { data } = this.state;
        return(
            <InputBox
            name={name}
            value={data[name]}
            label={label}
            rules={rules}
            onChange = {(e) => {this.handleChnage(e)} }
            />
        )
    }
    renderCheckbox(name,label,rules,){
        const { data } = this.state;
        return(
            <CheckBox
            name={name}
            value={data[name]}
            label={label}
            rules={rules}
            onChange = {(e) => {this.handleChnage(e)} }
            />
        )
    }
    renderTextFeild(name,label,rules){
        const { data } = this.state;
        return(
            <TextFieldBox
            name={name}
            value={data[name]}
            label={label}
            rules={rules}
            onChange = {(e) => {this.handleChnage(e)} }
            />
        )
    }
    renderSelect(name,label,rules,placeholder, options,mode){
        const { data } = this.state;
        return(
            <SelectBox
            name={name}
            value={data[name]}
            label={label}
            rules={rules}
            options={options}
            mode={mode}
            placeholder={placeholder}
            onChange = {(e) => {this.handleChnage(e)} }
            />
        )
    }
}
 
export default CommonForm;

export const renderInput = (name, label, rules, size, type) => {
    return(
        <InputBox
        name={name}
        label={label}
        rules={rules}
        size={size}
        type={type}
        />
    )
}
export const renderSelect = (name,label,rules,placeholder, options,mode, size) => {
    return(
        <SelectBox
        name={name}
        label={label}
        rules={rules}
        options={options}
        mode={mode}
        placeholder={placeholder}
        size={size}
        />
    )
}

export const renderCheckbox = (name,label,rules, size) => {
    return(
        <CheckBox
        name={name}
        label={label}
        rules={rules}
        size={size}
        />
    )
}

export const renderTextField = (name,label,rules, size) => {
    return(
        <TextFieldBox
        name={name}
        label={label}
        rules={rules}
        size={size}
        />
    )
}

export const renderDate = (name,label,rules, value, size) => {
    return(
        <DateBox
        name={name}
        label={label}
        rules={rules}
        size={size}
        />
    )
}
export const renderFile = (name,label,rules, size) => {
    return(
        <FileBox
            name={name}
            label={label}
            rules={rules}
            size={size}
        />
    )
}